import { ROUTE_AUTHORIZED_TO_CONDUCT } from 'CorePackage/MainModule/routes/routes';

import { CommonCatalogsNamesEnum } from '../enums/CommonCatalogsNamesEnum';

export const routesToUpdateCatalogs: Record<string, CommonCatalogsNamesEnum[]> = {
  [ROUTE_AUTHORIZED_TO_CONDUCT]: [CommonCatalogsNamesEnum.KNM_INSPECTORS],
};
